import React from 'react';
import { QRCode } from 'react-qrcode-logo';
import CustomModal from '../../../../../components/Modal/CustomModal';
import {DownloadIconSvg} from '../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import GenerateVCardApp from '../Functionality/GenerateVCardApp';

const GenerateVCard = ({ show, onHide }) => {

    const {t, qrValue, qrColor, vCardImage, bgColor, qrSize, qrRef,
        handleDownload
    } =GenerateVCardApp({show})

    return (

        <CustomModal
            title={t('VCARD')}
            size='md'
            buttonConfirm='add'
            show={show}
            onHide={onHide}
            cancelButton={false}
            confirmButton={false}
        >
            <div className='col-12 d-flex'>
                <div className='vcard-container-modal' ref={qrRef}>
                    <QRCode
                        title='VCard'
                        value={qrValue}
                        bgColor={bgColor}
                        fgColor={qrColor}
                        size={qrSize}
                        padding={0}
                        logoOpacity={0.9}
                        logoWidth={60}
                        logoImage={vCardImage}
                        logoHeight='60'
                        ecLevel='L'
                        logoPadding={10}
                        removeQrCodeBehindLogo='true'
                    />
                </div>
                <ButtonIcon
                    id='btn_gvc_download'
                    Icon={DownloadIconSvg}
                    className='btn-background-transparent'
                    iconProps='btn-icon-svg-gray btn-icon-svg-12px'
                    onClick={()=>{
                        handleDownload();
                    }}
                />
            </div>

        </CustomModal>
    );
};

export default GenerateVCard;
